<template>
  <Modal :active="active" :vehicle="vehicle" :title="$t('forms.tradeIn.title')" @modalClosed="closeModal">
    <div class="form-modal-intro">
      <div v-if="introText" v-html="introText"></div>
    </div>

    <div v-if="WPSettings.LANGUAGE !== 'nl'" class="infoMessage">{{ $t('forms.noTranslationAvailable') }}</div>

    <iframe
      id="taxtoolFrame"
      :class="{ '-loading': !iframeLoaded }"
      ref="taxtoolFrame"
      :src="'https://taxatie.i-motive.nl/?client=' + clientId + '&vehicle_data=' + encodedVehicleData"
      frameborder="0"
      border="0"
      width="100%"
      height="540px"
      @load="iframeHasLoaded"
    ></iframe>
  </Modal>
</template>

<style lang="scss">
#taxtoolFrame.-loading {
  background: url('../../assets/icons/loading-spinner.svg') center center no-repeat;
  background-size: 200px 200px;
}
</style>

<script>
import Modal from '@/components/Modal'
import { WPSettings } from '@/WPSettings'
import { encode } from 'js-base64'

export default {
  name: 'modalTaxTool',
  data() {
    return {
      WPSettings: WPSettings,
      iframeLoaded: false,
    }
  },
  watch: {
    active(val) {
      // Reset spinner
      if (val === true) {
        this.iframeLoaded = false
      }
    },
  },
  props: ['active', 'clientId', 'introText', 'vehicle'],
  computed: {
    encodedVehicleData() {
      const currentVehicle = this.$store.getters['vehicles/current']
      const vehicleData = {
        brand: currentVehicle.properties.brand,
        model: currentVehicle.properties.model,
        is_tax: currentVehicle.properties.btwMarge === 'BTW' && currentVehicle.properties.priceInclTax === false,
        price: currentVehicle.properties.price,
        license: currentVehicle.properties.license,
      }
      return encode(JSON.stringify(vehicleData))
    },
  },
  components: {
    Modal,
  },
  methods: {
    closeModal() {
      // Emit to parent component
      this.$emit('modalClosed', true)

      // Reset errors - just because it's prettier
      this.errors = []
    },

    iframeHasLoaded() {
      this.iframeLoaded = true
    },
  },
  updated: function () {
    // Resize events for the taxtool frame
    const frameEl = this.$refs.taxtoolFrame

    if (frameEl) {
      const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent'
      const eventer = window[eventMethod]
      const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message'

      eventer(
        messageEvent,
        function (e) {
          if (typeof e.data === 'string' && e.data.indexOf('documentHeight') > -1) {
            let height = e.data.split('documentHeight:')[1]
            height = parseInt(height) + 90
            frameEl.height = height + 'px'
          }
        },
        false
      )
    }
  },
}
</script>
